// extracted by mini-css-extract-plugin
export var orderDetails = "_sb-2";
export var orderImage = "_sb-1";
export var orderMeta = "_sb-3";
export var orderSummary = "_sb-0";
export var rightArrow = "_sb-4";